import "./naf-insurance-task-banner.scss";
import nafInsuranceBlue from "assets/images/v2/naf-insurance-logo-blue.svg";
import { Button } from "components/ui/button/Button";
import { useState } from "react";
import { NAF_INSURANCE_TASKS_BANNER_CTA, NAF_INSURANCE_TASKS_BANNER_TEXT } from "utilities/Constant";
import NafInsurancePanel from "../naf-insurance-panel/NafInsurancePanel";
import { trackFSInsuranceTaskCTAClick } from "utilities/full-story";
import { useInsuranceFullStoryTrackingProps } from "hooks/useInsuranceFullStoryTrackingProps";

export default function NafInsuranceTaskBanner() {
  const [isInsuranceModalOpen, setIsInsuranceModalOpen] = useState(false);
  const insuranceTrackingProps = useInsuranceFullStoryTrackingProps();

  const handleCtaClick = () => {
    trackFSInsuranceTaskCTAClick(insuranceTrackingProps);
    setIsInsuranceModalOpen(true);
  };

  return (
    <>
      <div className="naf-insurance-task-banner">
        <div className="naf-insurance-task-banner__logo"><img src={nafInsuranceBlue} alt="NAF Insurance logo" /></div>
        <div className="naf-insurance-task-banner__content">
          <div className="naf-insurance-task-banner__content-text paragraph-small-regular">
            {NAF_INSURANCE_TASKS_BANNER_TEXT}
          </div>
          <div className="naf-insurance-task-banner__content-link paragraph-small-regular">
            <Button
              type="link"
              title={NAF_INSURANCE_TASKS_BANNER_CTA}
              className="naf-insurance-task-banner__content-link-button"
              onClick={handleCtaClick}
            />
          </div>
        </div>
      </div>
      {isInsuranceModalOpen && (
        <NafInsurancePanel
          onClose={() => setIsInsuranceModalOpen(false)}
          isTaskReferral
        />
      )}
      </>
  );
}